import { ANALYTICS_INCIDENT_REPORTS_BY_TYPE, STATISTICS } from 'app/api-routes';
import axios from 'axios';
import { put, all, takeLatest } from 'redux-saga/effects';
import {
  biIncidentReportsByTypeFailure,
  biIncidentReportsByTypeRequest,
  biIncidentReportsByTypeSuccess,
  biIncidentReportsGroupedByDateAndTypeFailure,
  biIncidentReportsGroupedByDateAndTypeRequest,
  biIncidentReportsGroupedByDateAndTypeSuccess,
  biIncidentReportsGroupedByDateFailure,
  biIncidentReportsGroupedByDateRequest,
  biIncidentReportsGroupedByDateSuccess,
  setLoadingState,
} from './actions';
import moment from 'moment';
import { SERVER_DATE_TIME_FORMAT } from 'app/types/constants';
import { formatDateTimeUTC } from 'util/formatting';
import _ from 'lodash';

function* biIncidentReportsByTypeSaga({ payload: { siteID, userID, supervisorID, typeIDs, month, year } }) {
  try {
    const startDate = formatDateTimeUTC(moment(`${year}-${month}`).startOf('month'), SERVER_DATE_TIME_FORMAT);
    const endDate = formatDateTimeUTC(moment(`${year}-${month}`).endOf('month'), SERVER_DATE_TIME_FORMAT);
    const params = { startDate, endDate };

    if (userID) {
      params.userID = userID;
    }

    if (siteID) {
      params.siteID = siteID;
    }

    if (supervisorID) {
      params.supervisorID = supervisorID;
    }

    if (!_.isEmpty(typeIDs)) {
      params.typeIDs = typeIDs;
    }

    yield put(biIncidentReportsByTypeSuccess([]));

    const { payload, warnings } = yield axios.get(ANALYTICS_INCIDENT_REPORTS_BY_TYPE, { params });
    yield put(biIncidentReportsByTypeSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biIncidentReportsByTypeFailure(err));
  }
}

function* biIncidentReportsGroupedByDateAndTypeSaga({
  payload: { startDate, endDate, siteID, userID, typeIDs, status, month, year },
}) {
  try {
    yield put(setLoadingState(true));

    if (!startDate || !endDate) {
      startDate = formatDateTimeUTC(moment(`${year}-${month}`).startOf('month'), SERVER_DATE_TIME_FORMAT);
      endDate = formatDateTimeUTC(moment(`${year}-${month}`).endOf('month'), SERVER_DATE_TIME_FORMAT);
    }

    const params = { startDate, endDate, timeZoneOffset: moment().utcOffset() };

    if (siteID) {
      params.siteID = siteID;
    }

    if (userID) {
      params.userID = userID;
    }

    if (!_.isEmpty(typeIDs)) {
      params.typeIDs = typeIDs;
    }

    if (status) {
      params.status = status;
    }

    const { payload } = yield axios.get(`${STATISTICS}/incident-reports/grouped-by-date-and-type`, {
      params,
    });

    yield put(biIncidentReportsGroupedByDateAndTypeSuccess(payload));
  } catch (err) {
    yield put(biIncidentReportsGroupedByDateAndTypeFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* IncidentReportsGroupedByDateSaga({ payload: { month, year, siteID, userID, typeIDs, status } }) {
  try {
    yield put(setLoadingState(true));

    const params = { month, year, timeZoneOffset: moment().utcOffset() };

    if (siteID) {
      params.siteID = siteID;
    }

    if (userID) {
      params.userID = userID;
    }

    if (!_.isEmpty(typeIDs)) {
      params.typeIDs = typeIDs;
    }

    if (status) {
      params.status = status;
    }

    const { payload } = yield axios.get(`${STATISTICS}/incident-reports/grouped-by-date`, {
      params,
    });

    yield put(biIncidentReportsGroupedByDateSuccess(payload));
  } catch (err) {
    yield put(biIncidentReportsGroupedByDateFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

export default function* () {
  yield all([
    yield takeLatest(biIncidentReportsByTypeRequest, biIncidentReportsByTypeSaga),
    yield takeLatest(biIncidentReportsGroupedByDateAndTypeRequest, biIncidentReportsGroupedByDateAndTypeSaga),
    yield takeLatest(biIncidentReportsGroupedByDateRequest, IncidentReportsGroupedByDateSaga),
  ]);
}
